module.exports = __webpack_public_path__ + "img/message.cf350795.svg";